import { withStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
import constants from '../../../../../../constants';
import Tooltip from '../../../../../../../../../../common/StyledToolTip';
import { Fullscreen as MaximizeIcon, FullscreenExit as MinimizeIcon } from '@material-ui/icons';

const styles = (theme) => ({
  headerStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerLeftSection: {
    padding: 14
  },
  headerLabel: {
    fontSize: theme.headerTextFontSize,
    color: theme.HeaderSelectedText,
    fontWeight: 600
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  detailRow: {
    flexDirection: 'column',
    marginRight: 20
  },
  label: {
    color: theme.recommendationCardStatusTextColor,
    fontSize: theme.dispatchCardTextFontSize,
    fontWeight: 400
  },
  value: {
    marginTop: 4,
    wordBreak: 'break-word',
    maxWidth: 250,
    color: theme.gridTextColor,
    fontSize: theme.textFontSize,
    fontWeight: 500
  },
  loaderContainer: {
    display: 'flex',
    alignItems: 'center',
    color: theme.iconColor,
    fontSize: theme.dispatchCardTextFontSize,
    margin: '14 0 4 0'
  },
  loader: {
    alignSelf: 'center',
    marginRight: 10
  },
  iconLayout: {
    cursor: 'pointer',
    float: 'left',
    alignSelf: 'flex-start',
    padding: 14,
    color: theme.iconColor,
    '&>span': {
      padding: '10px 10px',
      color: theme.iconColor
    }
  },
  missedStops: {
    color: theme.ErrorMessageColor,
  },
});

const DetailItem = ({ label, value, classes, showErrorColor = false }) => (
  <div className={classes.detailRow}>
    <div className={`${classes.value} ${showErrorColor ? classes.missedStops : ''}`}>
      {value ?? 'N/A'}
    </div>
    <div className={classes.label}>{label}</div>
  </div>
);

const PickupDetails = ({ classes, driverKpiData }) => {
  return (
    <div className={classes.container}>
      <DetailItem label="Stops" value={driverKpiData.totalStops} classes={classes} />
      <DetailItem label="Total Time" value={driverKpiData.estimatedTravelTime} classes={classes} />
      <DetailItem
        label="Total Miles"
        value={driverKpiData.estimatedMilesRemaining}
        classes={classes}
      />
      <DetailItem
        label="Return to Term"
        value={driverKpiData.arriveAtTerminalTime}
        classes={classes}
      />
      <DetailItem
        label="Missed Stops"
        value={driverKpiData.numServiceViolations}
        classes={classes}
        showErrorColor={driverKpiData.numServiceViolations > 0}
      />
    </div>
  );
};

const MapHeader = ({
  mapId,
  classes,
  headerLabel,
  driverKpiData,
  isMaximized,
  mapConfig,
  toggleMaximize,
  shouldShowRoutePreview
}) => {
  return (
    <div className={classes.headerStyle}>
      <div className={classes.headerLeftSection}>
        <span className={classes.headerLabel}>{headerLabel}</span>
        {mapConfig.loading ? (
          <span className={classes.loaderContainer}>
            <CircularProgress size={16} className={classes.loader} />
            {constants.API_MESSAGES.LOADING_DRIVER_KPI}
          </span>
        ) : (
          <>
            {shouldShowRoutePreview && (
              <PickupDetails driverKpiData={driverKpiData} classes={classes} />
            )}
          </>
        )}
      </div>
      <div className={`${classes.iconLayout} glHeaderIcons`} onClick={() => toggleMaximize(mapId)}>
        <Tooltip title={isMaximized ? 'Minimize' : 'Maximize'}>
          {isMaximized ? <MinimizeIcon /> : <MaximizeIcon />}
        </Tooltip>
      </div>
    </div>
  );
};

export default withStyles(styles)(MapHeader);
